import { render, staticRenderFns } from "./blank.vue?vue&type=template&id=c966e300&scoped=true"
import script from "./blank.vue?vue&type=script&lang=ts"
export * from "./blank.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c966e300",
  null
  
)

export default component.exports